module.exports = ['$scope', '$state', 'ngToast', 'ngDroUAA', function ($scope, $state, ngToast, ngDroUAA) {

        $scope.logout = function () {
            ngDroUAA.logout().then(function () {
                $state.go("login");                
            }).catch(function (reason) {
                if (reason.status !== 401 && reason.status !== 403) {
                    ngToast.danger('Impossibile eseguire la logout.');
                }else{
                     $state.go("login"); 
                }
            });
        };

        $scope.logout();
    }];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-core/components/logout/logoutCtrl.js
// module id = 312
// module chunks = 0